import React, { Fragment } from 'react'
import Card from 'lib/Card'
import Image from 'lib/Image'
import option from "../../assets/images/option.svg"
import "./index.scss"
import Group from 'lib/Group'
import DynamicForm from 'components/DynamicForm'


const ClientDetails = (props) => {

    const { formSkeleton, activeTab, setActiveTab } = props

    return (
        <div className='client_details'>
            <div className='client_details_container'>
                {formSkeleton?.[1]?.form_groups.map((item, index) => {
                    const {options, type, title} = item
                    return (
                        <>
                            {type ? <DynamicForm formFields={item} activeTab={activeTab} setActiveTab={setActiveTab} /> : (
                                <Fragment key={index}>
                                    {
                                        item.form_elements?.map((_item, index) => {
                                            const { input_fields, type} = _item
                                            return (
                                                <Card
                                                    className="client_details_card"
                                                    id={title}
                                                >
                                                    <div className="client_details_header">
                                                        <p className="title">
                                                            {title}
                                                        </p>
                                                        {options ? (
                                                            <Image
                                                                imageSrc={
                                                                    option
                                                                }
                                                            />
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                    {type == 'group' ? (
                                                        <Group
                                                            formFields={
                                                                input_fields
                                                            }
                                                        />
                                                    ) : (
                                                        <DynamicForm
                                                            formFields={_item}
                                                        />
                                                    )}
                                                </Card>
                                            );
                                        })
                                    }

                                </Fragment>
                            )}
                        </>
                    )
                })}
            </div>
            <div className='activity_container d-none d-lg-block'>
                {
                    formSkeleton?.[0]?.form_groups.map((item) => {
                        return (
                            <DynamicForm formFields={item} />
                        )
                    })
                }
            </div>
        </div>
    )
}

export default ClientDetails